/* eslint-disable */
/* this file is generated by generateIcons script */

// @ts-ignore
import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AccountTypeCustomerIcon extends BaseIcon {
    getChildren = () => [ <g transform="translate(0 -11)">
        <g transform="translate(0 11)">
            <circle cx="15.777" cy="15.777" r="15.777" fill="#f2f2f2"/>
            <g transform="translate(7.566 9.293)">
                <path d="M8.147.879A9.524,9.524,0,0,0,4.565.147,9.373,9.373,0,0,0,1.007.879a.772.772,0,0,0-.414.685V4.105a5.321,5.321,0,0,0,3.23,4.664l.371.158a.932.932,0,0,0,.741,0L5.3,8.769A5.365,5.365,0,0,0,8.561,4.105V1.585A.775.775,0,0,0,8.147.879ZM6.912,2.866,4.589,5.975a.685.685,0,0,1-.55.288.677.677,0,0,1-.426-.158L2.8,5.42A.551.551,0,0,1,2.712,4.7a.434.434,0,0,1,.649-.1l.618.534L6.22,2.208a.438.438,0,0,1,.655-.068.535.535,0,0,1,.161.352.551.551,0,0,1-.111.374Z" transform="translate(-0.593 1.91)" fill="#2e3f58"/>
                <g transform="translate(10.158)">
                    <circle cx="1.544" cy="1.544" r="1.544" transform="translate(2.535 12.969) rotate(-90)" fill="#2e3f58"/>
                    <circle cx="1.544" cy="1.544" r="1.544" transform="translate(2.535 8.028) rotate(-90)" fill="#2e3f58"/>
                    <circle cx="1.544" cy="1.544" r="1.544" transform="translate(2.535 3.088) rotate(-90)" fill="#2e3f58"/>
                    <path d="M0,0V4.582" transform="translate(0.002 6.485) rotate(-90)" fill="none" stroke="#2e3f58" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
                    <path d="M0,0V4.582" transform="translate(0 3.925) rotate(-120)" fill="none" stroke="#2e3f58" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
                    <path d="M0,4.582V0" transform="translate(3.97 11.337) rotate(120)" fill="none" stroke="#2e3f58" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
                </g>
            </g>
        </g>
    </g> ]
    getViewBox = () => '0 0 31.555 31.555'
}
